var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',_vm._g(_vm._b({class:{ button: true, r21: _vm.r21, r23: _vm.r23, r26: _vm.r26, r28: _vm.r28 },style:({ width: _vm.width, height: _vm.height }),attrs:{"ar":_vm.$i18n.locale === 'ar',"active":_vm.active,"size":_vm.size}},'a-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }